
const globalConfig = {
    appBarTop: 70,
    mapKey: "AIzaSyCflHun-d9nr6xQVc7-bC0FO1SUNE8QZWA",
    recaptchaKey: "6LfricwpAAAAAM7DtlUx5iNOe4g4YzJCcpaCWKIC",
    recaptchaSecret: "6LfricwpAAAAAJrjuStOKP82sLdakOuMeF1GRmCP",
  };
  
  export default globalConfig;